'use client';
'use strict';

var classes = {"wrapper":"m-fee9c77","preview":"m-9dddfbac","body":"m-bffecc3e","sliders":"m-3283bb96","thumb":"m-40d572ba","swatch":"m-d8ee6fd8","swatches":"m-5711e686","saturation":"m-202a296e","saturationOverlay":"m-11b3db02","slider":"m-d856d47d","sliderOverlay":"m-8f327113"};

module.exports = classes;
//# sourceMappingURL=ColorPicker.module.css.cjs.map
